const TAILWIND_SIZE_MAP = {
  'text-xs': '0.75rem',
  'text-sm': '0.875rem',
  'text-base': '1rem',
  'text-lg': '1.125rem',
  'text-xl': '1.25rem',
  'text-2xl': '1.5rem',
  'text-3xl': '1.875rem',
  'text-4xl': '2.25rem',
  'text-5xl': '3rem',
  'text-6xl': '3.75rem',
};

export function applyStyle(styleObj) {
  if (!styleObj) return {};
  const s = {};
  if (styleObj.fontFamily) s.fontFamily = `'${styleObj.fontFamily}', sans-serif`;
  if (styleObj.color) s.color = styleObj.color;
  if (styleObj.fontSize) {
    const mapped = TAILWIND_SIZE_MAP[styleObj.fontSize];
    if (mapped) s.fontSize = mapped;
  }
  return s;
}

export function applyClass(styleObj, defaultClass = '') {
  if (!styleObj?.fontSize) return defaultClass;
  return defaultClass.replace(/text-\w+/g, '').trim() + ' ' + styleObj.fontSize;
}
